import React, { useRef, useState } from "react";
import Tippy from "@tippyjs/react";

import useClickOutside from "../../utils/CustomHooks/useClickOutside";

const DropdownButton = ({
    buttonName,
    options,
    icon,
    disabled,
    className = "",
    menuClassNames = "w-56",
    optionsClassNames = "",
    optionsItemClassNames = "",
    tooltip,
    removeArrow = false,
    iconSize = "fa-sm",
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const isTriggered = useRef(false);
    const menuRef = useClickOutside(() => {
        if (isTriggered.current) {
            closeTrigger();
        }
    });

    const toggleTrigger = () => {
        setIsOpen((prev) => !prev);
        isTriggered.current = !isTriggered.current;
    };

    const closeTrigger = () => {
        setIsOpen(false);
        isTriggered.current = false;
    };

    const renderOptions = () => {
        const renderButton = (option) => {
            return (
                <>
                    <button
                        onClick={() => {
                            option.callback();
                            closeTrigger();
                        }}
                        disabled={option.disabled}
                        className={`default-orange-outline-btn export-options flex items-center w-full h-full px-2 py-4 ${optionsClassNames} ${
                            option.disabled ? "disabled" : ""
                        }`}
                    >
                        <div
                            className={`flex items-center gap-1 ${optionsItemClassNames}`}
                        >
                            {option.icon && (
                                <i className={`fas fa-${option.icon}`} />
                            )}

                            {option.displayName || option.label}
                        </div>
                    </button>
                    {option.horizontalLine && <hr className="mx-2 my-1" />}
                </>
            );
        };

        return options?.map((option, index) => {
            return (
                <span key={index}>
                    {option.tooltip ? (
                        <Tippy
                            content={option.tooltip}
                            placement="bottom"
                            animation="scale"
                        >
                            {renderButton(option, index)}
                        </Tippy>
                    ) : (
                        <div>{renderButton(option, index)}</div>
                    )}
                </span>
            );
        });
    };
    return (
        <Tippy
            content={tooltip}
            placement="bottom"
            animation="scale"
            disabled={!tooltip}
        >
            <div className="filter-content-wrapper menu" ref={menuRef}>
                <button
                    className={`default-orange-btn ${className} flex gap-2 items-center`}
                    disabled={disabled}
                    onClick={toggleTrigger}
                >
                    {icon && <i className={`${icon} ${iconSize}`} />}
                    {buttonName}
                    {!removeArrow && (
                        <i className="fas fa-chevron-down fa-sm ml-1" />
                    )}
                </button>
                <div className={`filter-items shadow ${isOpen ? "show" : ""}`}>
                    <div
                        className={`origin-top-right absolute right-0 mt-2 ${menuClassNames} rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-20`}
                    >
                        {renderOptions()}
                    </div>
                </div>
            </div>
        </Tippy>
    );
};

export default DropdownButton;
